export default __webpack_public_path__ + "static/media/bg_main_games.86ff139a.png";